import Password from './Password.jsx';
export default Password;



// WEBPACK FOOTER //
// ./src/components/Password/index.js